'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'sparkles';
var width = 576;
var height = 512;
var aliases = [10024];
var unicode = 'f890';
var svgPathData = ['M16 256l115 53.1c3.5 1.6 6.2 4.4 7.8 7.8L192 432 245.1 317c1.6-3.5 4.4-6.2 7.8-7.8L368 256 253 202.9c-3.5-1.6-6.2-4.4-7.8-7.8L192 80 138.9 195c-1.6 3.5-4.4 6.2-7.8 7.8L16 256z', 'M496 8c4.4 0 8 3.6 8 8l0 56 56 0c4.4 0 8 3.6 8 8s-3.6 8-8 8l-56 0 0 56c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-56-56 0c-4.4 0-8-3.6-8-8s3.6-8 8-8l56 0 0-56c0-4.4 3.6-8 8-8zM464 360c4.4 0 8 3.6 8 8l0 56 56 0c4.4 0 8 3.6 8 8s-3.6 8-8 8l-56 0 0 56c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-56-56 0c-4.4 0-8-3.6-8-8s3.6-8 8-8l56 0 0-56c0-4.4 3.6-8 8-8zM131 202.9L16 256 131 309.1c3.5 1.6 6.2 4.4 7.8 7.8L192 432 245.1 317c1.6-3.5 4.4-6.2 7.8-7.8L368 256 253 202.9c-3.5-1.6-6.2-4.4-7.8-7.8L192 80 138.9 195c-1.6 3.5-4.4 6.2-7.8 7.8zm-6.7 120.8L9.3 270.5C3.6 267.9 0 262.2 0 256s3.6-11.9 9.3-14.5l115-53.1 53.1-115c2.6-5.7 8.3-9.3 14.5-9.3s11.9 3.6 14.5 9.3l53.1 115 115 53.1c5.7 2.6 9.3 8.3 9.3 14.5s-3.6 11.9-9.3 14.5l-115 53.1-53.1 115c-2.6 5.7-8.3 9.3-14.5 9.3s-11.9-3.6-14.5-9.3l-53.1-115z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSparkles = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;